import { defineMessages } from 'react-intl';

export default defineMessages({
    step1Title: {
        id: 'portal.vies.FNOLWizard.Steps.Step1.Title',
        defaultMessage: 'Find and select your policy'
    },
    step2Title: {
        id: 'portal.vies.FNOLWizard.Steps.Step2.Title',
        defaultMessage: 'Enter claim details'
    },
    step3Title: {
        id: 'portal.vies.FNOLWizard.Steps.Step3.Title',
        defaultMessage: 'Claim reported'
    },
    back: {
        id: 'ax.FNOLWizard.Steps.back.Title',
        defaultMessage: 'Back'
    },
    titleAlert: {
        id: 'ax.FNOLWizard.Steps.back.titleAlert',
        defaultMessage: 'Are you sure to cancell this claim?'
    },
    messageAlert: {
        id: 'ax.FNOLWizard.Steps.back.messageAlert',
        defaultMessage: 'The info to be delete clic yes to delete info or clic not to continue'
    },
    yes: {
        id: 'ax.FNOLWizard.Steps.back.yes',
        defaultMessage: 'yes'
    },
    not: {
        id: 'ax.FNOLWizard.Steps.back.not',
        defaultMessage: 'not'
    }
});
